import React, { createContext, useContext, useState } from 'react';
import { Platform } from 'react-native';

type PullDownRefreshContextType = {
  canRefresh: boolean;
  setCanRefresh: (val: boolean) => void;
};

const PullDownRefreshContext = createContext<PullDownRefreshContextType | undefined>(undefined);

export const usePullDownRefreshContext = () => {
  const context = useContext(PullDownRefreshContext);
  if (!context || Platform.OS === 'web') {
    return {
      canRefresh: false,
      setCanRefresh: () => {}, // no-op for web
    };
  }
  // if (!context) {
  //   throw new Error('usePullDownRefreshContext must be used within PullDownRefreshProvider');
  // }
  return context;
};

export const PullDownRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [canRefresh, setCanRefresh] = useState(false);

  return (
    <PullDownRefreshContext.Provider value={{ canRefresh, setCanRefresh }}>
      {children}
    </PullDownRefreshContext.Provider>
  );
};
